import { ServiceCategory } from './service-categories-types';

export const FETCH_SERVICE_CATEGORIES = {
  init: 'serviceCategories/FETCH_SERVICE_CATEGORIES/init',
  request: 'serviceCategories/FETCH_SERVICE_CATEGORIES/request',
  success: 'serviceCategories/FETCH_SERVICE_CATEGORIES/success',
  failure: 'serviceCategories/FETCH_SERVICE_CATEGORIES/failure',
  cancel: 'serviceCategories/FETCH_SERVICE_CATEGORIES/cancel',
} as const;

export const SERVICE_CATEGORIES_RESET = 'serviceCategories/RESET' as const;

export const SERVICE_CATEGORIES_STORE_NAME = 'serviceCategories' as const;

export const MOSCOW_ROUGH_REPAIR: ServiceCategory = {
  topCategoryId: 99999,
  topCategoryName: 'Черновой ремонт',
  topCategoryType: "OUTSTORE",
  topCategoryUrl: '/uslugi/chernovoy-remont/',
};
